import { Box, Collapse, IconButton, TableCell, TableRow } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { useTheme } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import { capitalize } from 'lodash';
import ProductFulfillmentLineItemsRow from './ProductFulfillmentLineItemsRow';

const ProductFulfillmentRow = ({ order, partnerAccountHandler }) => {
  const theme = useTheme();
  const [showDetails, setShowDetails] = useState();

  const toggleDetails = () => setShowDetails((show) => !show);

  const getPartnerAccountName = (partnerAccountId) => {
    return partnerAccountId && partnerAccountHandler[partnerAccountId]
      ? capitalize(partnerAccountHandler[partnerAccountId].partnerAccountName)
      : 'N/A';
  };

  const { mpi, patientName, orderId, requestNeedsByDate } = order;
  const { partnerName, partnerAccountId } = order;

  return (
    <>
      <TableRow key={orderId} hover>
        <TableCell sx={{ py: 1 }}>
          <IconButton aria-label={`Toggle Details ${orderId}`} size='small' onClick={toggleDetails}>
            {showDetails ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>{orderId}</TableCell>
        <TableCell component='th' scope='row'>
          <Link to={`/patients/${mpi}`} style={{ color: theme.palette.text.primary }}>
            {patientName}
          </Link>
        </TableCell>
        <TableCell>{capitalize(partnerName)}</TableCell>
        <TableCell>{getPartnerAccountName(partnerAccountId)}</TableCell>
        <TableCell>{order.qs1Id}</TableCell>
        <TableCell>
          {format(utcToZonedTime(new Date(requestNeedsByDate), 'utc'), 'MM/dd/yyyy')}
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell colSpan={6} sx={{ p: 0, border: 'none' }}>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Collapse in={showDetails} timeout='auto' sx={{ width: '100%' }}>
              {order?.lineItems && (
                <ProductFulfillmentLineItemsRow
                  lineItemRow={order.orderId}
                  lineItems={order.lineItems}
                />
              )}
            </Collapse>
          </Box>
        </TableCell>
      </TableRow>
    </>
  );
};

ProductFulfillmentRow.propTypes = {
  order: PropTypes.shape({
    mpi: PropTypes.string.isRequired,
    patientName: PropTypes.string.isRequired,
    orderId: PropTypes.string.isRequired,
    requestNeedsByDate: PropTypes.string.isRequired,
    qs1Id: PropTypes.string,
    lineItems: PropTypes.arrayOf(
      PropTypes.shape({
        lineItemId: PropTypes.string,
        itemName: PropTypes.string,
        rxNumber: PropTypes.string,
        strength: PropTypes.string,
        form: PropTypes.string,
        quantity: PropTypes.string,
        fillType: PropTypes.string,
        needsByDate: PropTypes.string,
      })
    ).isRequired,
    partnerName: PropTypes.string.isRequired,
    partnerAccountId: PropTypes.string,
  }).isRequired,
  partnerAccountHandler: PropTypes.objectOf(
    PropTypes.shape({
      partnerAccountName: PropTypes.string.isRequired,
      partnerAccountId: PropTypes.string,
    })
  ).isRequired,
};

export default ProductFulfillmentRow;
